const FILES = {
  click: 'click.wav',
  select: 'select.wav',
  correct: 'correct.wav',
  wrong: 'wrong.wav',
  whoosh: 'whoosh.wav',
  lock: 'lock.wav',
  unlock: 'unlock.wav',
  hover: 'hover.wav',
  quiz: 'quiz.wav',
  alert: 'alert.wav',
  celebrate: 'celebrate.wav',
  retry: 'retry.wav',
  toggle: 'toggle.wav',
  drop: 'drop.wav',
  tick: 'tick.wav',
};

const buffers = new Map();
const SOUND_KEY = 'altec-academia-lgpd-sound';
let muted = false;
let unlocked = false;

export function isMuted() {
  return muted;
}

export function setMuted(value, storage) {
  muted = Boolean(value);
  try {
    storage?.setItem(SOUND_KEY, muted ? 'off' : 'on');
  } catch {
    /* ignore */
  }
  return muted;
}

export function initSound(storage) {
  const saved = storage?.getItem(SOUND_KEY);
  muted = saved === 'off';
  return muted;
}

export function toggleMuted(storage) {
  return setMuted(!muted, storage);
}

function url(file) {
  const base = import.meta.env.BASE_URL || './';
  return `${base}assets/sounds/${file}`;
}

function load(name) {
  if (buffers.has(name)) return buffers.get(name);
  const audio = new Audio(url(FILES[name]));
  audio.preload = 'auto';
  buffers.set(name, audio);
  return audio;
}

export function unlockAudio() {
  if (unlocked) return;
  unlocked = true;
  Object.keys(FILES).forEach((name) => load(name));
}

export function play(name) {
  if (muted || typeof Audio === 'undefined') return;
  unlockAudio();
  const src = buffers.get(name) || load(name);
  const node = src.cloneNode();
  node.volume = name === 'hover' ? 0.25 : 0.55;
  node.play().catch(() => {});
}
